import { Vue, Component, Prop, Provide, Emit } from 'vue-property-decorator'
import { extend, uniqueId } from 'lodash'
import { StatisticalAnalysisSidebarComponent, StatisticalAnalysisSidebarModel } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar.models'
import StatisticalAnalysisSidebarDateAndCenters from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar-date-and-centers/statistical-analysis-sidebar-date-and-centers.vue'
import StatisticalAnalysisSidebarSearchBy from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar-search-by/statistical-analysis-sidebar-search-by.vue'
import StatisticalAnalysisSidebarCheckbox from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar-checkbox/statistical-analysis-sidebar-checkbox.vue'
import StatisticalAnalysisSidebarSearchType from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar-search-type/statistical-analysis-sidebar-search-type.vue'
@Component({
    components: {
        StatisticalAnalysisSidebarDateAndCenters,
        StatisticalAnalysisSidebarSearchBy,
        StatisticalAnalysisSidebarCheckbox,
        StatisticalAnalysisSidebarSearchType
    }
})
export default class StatisticalAnalysisSidebar extends Vue {
    @Prop() readonly title!: string
    @Prop() readonly id!: string
    @Prop() readonly components!: StatisticalAnalysisSidebarComponent[]
    @Provide() externalValidator = this.$validator
    @Emit()
    search(value: StatisticalAnalysisSidebarModel): StatisticalAnalysisSidebarModel {
        return value
    }
    mountedComponents: number = 0

    get getUniqueIdComponent(): string {
        return uniqueId('statistical-component-element-')
    }

    async clear(): Promise<void> {
        await this.$validator.reset()
        this.$validator.pause()
        this.components.forEach((component: any, index: number) => {
            const refComponent = `${component.name}-${index}`
            const reference: any = this.$refs[refComponent] as any
            reference[0].clear()
        })
    }

    async onFind(avoidValidations: boolean = false): Promise<void> {
        if (avoidValidations) {
            this._sendAction()
        } else {
            this.$validator.resume()
            await this.$validator.validate()
            this.$validator.pause()
            const hasErrors = this.$validator.errors.count()
            if (!hasErrors) {
                this._sendAction()
            }
        }
    }

    async onComponentMounted() {
        this.mountedComponents++
        if (this.mountedComponents === this.components.length) {
            await this.onFind(true)
        }
    }

    private _sendAction(): void {
        let result: StatisticalAnalysisSidebarModel = {}
        this.components.forEach((component: any, index: number) => {
            const refComponent = `${component.name}-${index}`
            const reference: any = this.$refs[refComponent] as any
            result = extend({}, result, reference[0].getModel())
        })
        this.search(result)
    }
}
